import { render } from "./DiscussionInteractive.vue?vue&type=template&id=a6385aa2&scoped=true"
import script from "./DiscussionInteractive.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionInteractive.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionInteractive.vue?vue&type=style&index=0&id=a6385aa2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6385aa2"]])

export default __exports__